import { useEffect } from "react";

const BASE_TITLE = "SatyaBalTech Semiconductor";

function setMetaTag(name, content) {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
}

/**
 * Sets the document title and meta description for the current route.
 * Restores the previous values on unmount so navigating away is clean.
 */
function useDocumentMeta(pageTitle, description) {
    useEffect(() => {
        const previousTitle = document.title;
        const previousDescription = document.querySelector('meta[name="description"]')?.getAttribute("content");

        document.title = pageTitle ? `${pageTitle} | ${BASE_TITLE}` : BASE_TITLE;
        if (description) {
            setMetaTag("description", description);
        }

        return () => {
            document.title = previousTitle;
            if (previousDescription) {
                setMetaTag("description", previousDescription);
            }
        };
    }, [pageTitle, description]);
}

export default useDocumentMeta;
